import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../../mock';

export default function FAQ() {
  const [open, setOpen] = useState(null);

  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center">
          <h2 className="zp-section-title">
            FAQ<span className="zp-gradient-text">'s</span>
          </h2>
          <p className="mt-3 text-slate-600">Everything you want to know about Zoopers.</p>
        </div>

        <div className="mt-10 rounded-3xl bg-white border border-pink-100 shadow-[0_10px_40px_-24px_rgba(233,30,128,0.25)] p-3 md:p-6">
          {faqs.map((f, i) => (
            <div key={i} className="border-b border-pink-100 last:border-0">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between text-left px-3 py-4 font-semibold text-slate-900 hover:text-[#E91E80] transition-colors"
              >
                <span>{f.q}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 ml-4 transition-transform duration-200 text-[#E91E80] ${open === i ? 'rotate-180' : ''}`}
                />
              </button>
              {open === i && (
                <div className="text-slate-600 leading-relaxed px-3 pb-4 text-sm">{f.a}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
